import { Modal } from '@mui/material';
import { FormTextInput, GlobalButton, LoaderBackdrop } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { useBranchAddressForm } from '@/pages/Business/pages/PickupCycles/hooks';
import NeighborhoodAutocomplete from './NeighborhoodAutocomplete';

interface BranchAddressModalProps {
  open: boolean;
  branchId: string | null;
  onClose: () => void;
  onSaved: () => void;
}

const BranchAddressModal = ({
  open,
  branchId,
  onClose,
  onSaved,
}: BranchAddressModalProps) => {
  const {
    control,
    onFormSubmit,
    setNeighborhoodId,
    neighborhoodId,
    branchName,
    isLoadingBranch,
    isSaving,
  } = useBranchAddressForm({
    branchId,
    open,
    onSaved: () => {
      onSaved();
      onClose();
    },
  });

  return (
    <Modal open={open} onClose={onClose}>
      <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 max-h-[90vh] overflow-y-auto'>
        <form
          onSubmit={onFormSubmit}
          className='flex flex-col p-6 gap-5 w-[500px] bg-white outline-none rounded-lg shadow-xl'
        >
          <div className='flex flex-col gap-1'>
            <h2 className='text-xl font-bold text-gray-800'>
              Configurar dirección de sucursal
            </h2>
            {branchName && (
              <p className='text-sm text-gray-500'>{branchName}</p>
            )}
          </div>

          <div className='flex flex-col gap-4'>
            <FormTextInput
              name='streetName'
              control={control}
              placeholder='Calle'
              required
            />
            <FormTextInput
              name='doorNumber'
              control={control}
              placeholder='Número'
              required
            />
            <FormTextInput
              name='apartmentNumber'
              control={control}
              placeholder='Apartamento (opcional)'
            />
            <FormTextInput
              name='corner'
              control={control}
              placeholder='Esquina (opcional)'
            />
            <FormTextInput
              name='zipCode'
              control={control}
              placeholder='Código postal (opcional)'
            />
            <NeighborhoodAutocomplete
              value={neighborhoodId ?? ''}
              onChange={setNeighborhoodId}
            />
          </div>

          <div className='flex gap-3 justify-end mt-2'>
            <GlobalButton
              variant={GlobalButtonVariant.secondaryButton}
              action={onClose}
              disabled={isSaving}
            >
              Cancelar
            </GlobalButton>
            <GlobalButton
              variant={GlobalButtonVariant.primaryButton}
              action={onFormSubmit}
              disabled={isSaving || isLoadingBranch}
            >
              Guardar
            </GlobalButton>
          </div>
        </form>
        {(isSaving || isLoadingBranch) && <LoaderBackdrop />}
      </div>
    </Modal>
  );
};

export default BranchAddressModal;
